import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import showerror from "../../components/ErrorToast";
import axiosInstance, { pms_endpoint, rootUrl } from "../../utils/useAxios";
import showsuccess from "../../components/SuccessToast";


export const getTransactions = createAsyncThunk("transactions/gettransactions", async (payloaddata, thunkAPI) => {
    try {

        var url = `${rootUrl}${pms_endpoint}/business/${payloaddata?.businessid}/transactions/?`;

        if (payloaddata?.page) {
            url += `page=${payloaddata?.page}&`;
        }

        if (payloaddata?.size) {
            url += `size=${payloaddata?.size}&`;
        }

        const { data } = await axiosInstance.get(url);

        return data;
    } catch (error) {
        let errorMsg = "";

        if (error.response && error.response.data.error) {
            errorMsg = error.response.data.error[0];
        } else if (error.response && error.response.data.message) {
            errorMsg = error.response.data.message;
        } else if (error.response && error.response.data.detail) {
            errorMsg = error.response.data.detail;
        } else {
            errorMsg = error.message;
        }
        showerror(`Oops 😠,  ${errorMsg}`);
        return thunkAPI.rejectWithValue(errorMsg);
    }
});


export const sendTransactionWebhook = createAsyncThunk(
	"webhookevents/sendwebhook",
	async (post_data, thunkAPI) => {
		try {

            console.log({
                transactions:post_data.transactions ,
            },
                        );
            
			const { data } = await axiosInstance.post(
				`${rootUrl}${pms_endpoint}/business/${post_data?.businessid}/transactions/webhooks/dispatch/`,
				 {
    transactions:post_data.transactions ,
},
			);
			showsuccess("Webhook Notification push succesfully");
			return data;
		} catch (error) {
			let errorMsg = "";

			if (error.response && error.response.data.error) {
				errorMsg = error.response.data.error[0];
			} else if (error.response && error.response.data.message) {
				errorMsg = error.response.data.message;
			} else if (error.response && error.response.data.detail) {
				errorMsg = error.response.data.detail;
			} else {
				errorMsg = error.message;
			}
			showerror(`Oops 😠,  ${errorMsg}`);
			return thunkAPI.rejectWithValue(errorMsg);
		}
	},
);

export const getTransactionStats = createAsyncThunk("transactions/gettransactionStats", async (payloaddata, thunkAPI) => {
    try {

        var url = `${rootUrl}${pms_endpoint}/business/${payloaddata?.businessid}/transactions/stats`;

        const { data } = await axiosInstance.get(url);

        return data;
    } catch (error) {
        let errorMsg = "";

        if (error.response && error.response.data.error) {
            errorMsg = error.response.data.error[0];
        } else if (error.response && error.response.data.message) {
            errorMsg = error.response.data.message;
        } else if (error.response && error.response.data.detail) {
            errorMsg = error.response.data.detail;
        } else {
            errorMsg = error.message;
        }
        showerror(`Oops 😠,  ${errorMsg}`);
        return thunkAPI.rejectWithValue(errorMsg);
    }
});

const getTransactionsSlice = createSlice({
    name: "transactions",
    initialState: {
        sending: false,
        transactions: [],
        transactions_loading: false,
        selectedtransaction: [],

    },

    reducers: {
		updateSelectedTransaction: (state, action) => {
			state.selectedtransaction = action.payload;
		},
    },
    extraReducers: {
        [getTransactions.fulfilled]: (state, action) => {
            state.transactions_loading = false;
            state.transactions = action.payload;
        },
        [getTransactions.pending]: (state) => {
            state.transactions_loading = true;
        },
        [getTransactions.rejected]: (state) => {
            state.transactions_loading = false;
        },
        [getTransactionStats.fulfilled]: (state, action) => {
            state.transactionStats_loading = false;
            state.transactionStats = action.payload;
        },
        [getTransactionStats.pending]: (state) => {
            state.transactionStats_loading = true;
        },
        [getTransactionStats.rejected]: (state) => {
            state.transactionStats_loading = false;
        },
        [sendTransactionWebhook.fulfilled]: (state, action) => {
            state.sending = false;
            state.selectedtransaction = [];
        },
        [sendTransactionWebhook.pending]: (state) => {
            state.sending = true;
        },
        [sendTransactionWebhook.rejected]: (state) => {
            state.sending = false;
        },
    },
});

export const getTransactionsState = (state) => state.transactions;
export const { updateSelectedTransaction } = getTransactionsSlice.actions;
export default getTransactionsSlice.reducer;
